import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Link } from 'react-router-dom';
import './App.css';
import logo_laptop from './imgs/laptop.webp';
import BackToTop from './pages/BackToTop';
import ButtonZap from './components/ButtonZap';
import Title from './styled-components/Title';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Clients from './pages/Clients';
import Testimonials from './pages/Testimonials';
import Vantagens from './pages/Vantagens';
import ConsultDocuments from './pages/ConsultDocuments';



function App() {
  const [inProp, setInProp] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setInProp(true);
    }, 100);
  }, []);

  return (
    <div className="App">
      <CSSTransition
        in={inProp}
        timeout={500}
        classNames="fade"
        appear
        unmountOnExit
      >
        <main>
          {/* HERO */}
          <div id="main-app">
            <div className="particles">
              {[...Array(8)].map((_, i) => <span key={i}></span>)}
            </div>

            <img src={logo_laptop} alt="CEDOC Interface" />

            <div id="title-actions">
              <div id="titles">
                <Title>Inove a gestão da informação da sua empresa</Title>
                <h2>
                  Armazenamento seguro de documentos físicos, digitalização e certificação legal de documentos,
                  desenvolvimento de softwares de gestão documental.
                </h2>
              </div>

              <div id="button-actions">
                <Link id="demo" to="/formdemo">Solicite uma demonstração</Link>
                <Link id="client" to="/portais">Área do cliente</Link>
              </div>
            </div>
          </div>

          {/* Outras seções */}
          <ConsultDocuments bgImg="none" />
          <Services bgImg="none" />
          <Vantagens bgImg="none" />
          <Clients bgImg="none" />
          <Testimonials bgImg="none" />
          <About bgImg="none" />
          <Contact bgImg="none" />
        </main>
      </CSSTransition>

      <BackToTop />
      <ButtonZap />
    </div>
  );
}

export default App;
